'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('flickity-as-nav-for');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselWithNavInModal = function () {
  function CarouselWithNavInModal(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, CarouselWithNavInModal);

    this.el = el;
    this.isInitialised = false;

    var clickFnc = function clickFnc() {
      var isVisible = el.offsetParent != null;

      if (isVisible && _this.isInitialised === false) {
        _this.initialiseCarousels();

        document.body.removeEventListener('click', clickFnc);
      }
    };
    document.body.addEventListener('click', clickFnc);
  }

  (0, _createClass3.default)(CarouselWithNavInModal, [{
    key: 'initialiseCarousels',
    value: function initialiseCarousels() {
      new _flickity2.default((0, _functional.getElement)('.car-Slides_Items-carousel', { context: this.el }), {
        wrapAround: false,
        pageDots: false,
        initialIndex: 4,
        cellAlign: 'center',
        adaptiveHeight: true
      });

      new _flickity2.default((0, _functional.getElement)('.car-Slides_Items-carousel-nav', { context: this.el }), {
        asNavFor: (0, _functional.getElement)('.car-Slides_Items-carousel', {
          context: this.el
        }),
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: false,
        draggable: false,
        prevNextButtons: false
      });

      this.isInitialised = true;
    }
  }]);
  return CarouselWithNavInModal;
}();

exports.default = CarouselWithNavInModal;